import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { homeTableData } from "../../api/homeTableData";

const homeTableSlice = createSlice({
  name: "homeTable",
  initialState: {
    status: "idle",
    data: [],
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    hasNext: false,
    hasPrevious: false,
    searchQuery: "",
    showMine: true,
    filterStage: null,
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.currentPage = 1;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      state.currentPage = 1; 
    },
    setShowMine: (state, action) => {
      state.showMine = action.payload;
      state.currentPage = 1; 
    },
    setFilterStage: (state, action) => {
      state.filterStage = action.payload;
      state.currentPage = 1; 
    },
    setPageSize: (state,action) =>{
      state.pageSize = action.payload;
      state.currentPage=1;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchHomeTableList.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchHomeTableList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.totalCount = action.payload.count;
        state.hasNext = action.payload.next !== null;
        state.hasPrevious = action.payload.previous !== null;
      })
      .addCase(fetchHomeTableList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const selectHomeTableList = (state) => state.homeTable.data;
export const selectHomeTableStatus = (state) => state.homeTable.status;
export const selectCurrentPage = (state) => state.homeTable.currentPage;
export const selectPageSize = (state) => state.homeTable.pageSize;
export const selectTotalCount = (state) => state.homeTable.totalCount;
export const selectHasNext = (state) => state.homeTable.hasNext;
export const selectHasPrevious = (state) => state.homeTable.hasPrevious;
export const selectSearchQuery = (state) => state.homeTable.searchQuery;
export const selectShowMine = (state) => state.homeTable.showMine;
export const selectFilterStage = (state) => state.homeTable.filterStage;

export const {
  setCurrentPage,
  setPageSize,
  setSearchQuery,
  setShowMine,
  setFilterStage,
} = homeTableSlice.actions;

export const fetchHomeTableList = createAsyncThunk(
  "homeTable/fetchHomeTableList",
  async (params, { getState }) => {
    const state = getState().homeTable;
    const apiParams = {
      page: params?.page || state.currentPage,
      page_size: params?.page_size || state.pageSize,
      search: params?.search !== undefined ? params.search : state.searchQuery,
      user_id: params?.user_id,
      stage: params?.stage || state.filterStage,
    };
    
    return await homeTableData(apiParams);
  }
);

export default homeTableSlice.reducer;
